(function (window, angular) {
    'use strict';

    /*
        Gets the main angular module of the project
    */
    var app = angular.module('enervee');

    /**
     * Sends csrf tokens along with all unsafe requests
     *
     */
    app.config(
        ['$httpProvider',
        function($httpProvider) {
            $httpProvider.defaults.xsrfCookieName = 'csrftoken';
            $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
        }]
    );

    app.config(
        ['$analyticsProvider',
            function ($analyticsProvider) {
                $analyticsProvider.firstPageview(true);
                $analyticsProvider.withAutoBase(true);
            }
        ]
    );

    /**
     *  Cloudinary settings
     *  http://cloudinary.com/documentation/rails_additional_topics#configuration_options
     */
    app.config(
        ['cloudinaryProvider',
            function (cloudinaryProvider) {
                cloudinaryProvider.set("cloud_name", "enervee");
                cloudinaryProvider.set("private_cdn", true); // Use custom domain name instead of res.cloudinary.com/cloud_name/
                cloudinaryProvider.set("cname", "images.enervee.com"); // Custom domain name for HTTP URLs
                cloudinaryProvider.set("secure_distribution", "images.enervee.com"); // Custom domain name for HTTPS URLs
                cloudinaryProvider.set("secure", true); // Use HTTPS URLs always
            }
        ]
    );

    app.run(configureAnalyticsService);
    configureAnalyticsService.$inject = [
        'AccountAuthService',
        'AccountSettingsService',
        'AnalyticsService',
    ];
    function configureAnalyticsService(
        AccountAuthService,
        AccountSettingsService,
        AnalyticsService
    ) {
        AnalyticsService.registerUserDetailsFunction(function () {
            return AccountSettingsService.getAccountInfo();
        });
        AnalyticsService.registerUserStatusFunction(function () {
            return AccountAuthService.getUserStatus();
        });
    }

    app.config(configCategoriesService);
    configCategoriesService.$inject = ['CategoriesServiceProvider'];
    function configCategoriesService(CategoriesServiceProvider) {
        CategoriesServiceProvider.waitForFormatters(true);
    }

    app.run(setCategoryFormatters);
    setCategoryFormatters.$inject = ['CategoriesService', 'EnerveeCheckoutService'];
    function setCategoryFormatters(CategoriesService, EnerveeCheckoutService) {
        CategoriesService.addFormatter(EnerveeCheckoutService.applyCheckoutEnabledToCategories);
        CategoriesService.applyFormatters().then(function () {
            CategoriesService.finishInit();
        });
    }


    app.run(clearAdsOnStateChangeStart);
    clearAdsOnStateChangeStart.$inject = ['$rootScope', 'GoogleAdService'];
    function clearAdsOnStateChangeStart($rootScope, GoogleAdService) {
        $rootScope.$on('$stateChangeSuccess', () => GoogleAdService.clearAdSlots());
    }

    /**
     * Sets up an anonymous user id cookie for use with segment tracking
     */
    app.run(['$window', '$cookies', '$rootScope', 'AccountAuthService', 'UUIDService',
        function ($window, $cookies, $rootScope, AccountAuthService, UUIDService) {
            $rootScope.$on('$stateChangeSuccess', function () {
                let segmentAnonUserId = $cookies.get('segment_anon_user_id');
                if (!segmentAnonUserId && !AccountAuthService.isAuthenticated()) {
                    segmentAnonUserId = UUIDService.generate();
                    $cookies.put('segment_anon_user_id', segmentAnonUserId);
                }
                if (segmentAnonUserId !== null && $window.analytics) {
                    $window.analytics.user().anonymousId(segmentAnonUserId);
                }
            });
        }]
    );

    app.run(['$http', '$rootScope', '$interval',
        function ($http, $rootScope, $interval) {
            $rootScope.$on('$stateChangeSuccess', function() {
                function totalActiveAjaxRequests() {
                    return ($http.pendingRequests.length + $.active);
                }

                /**
                 * Check for completion of pending Ajax requests. When they're done,
                 * set prerenderReady to true for prerender.io
                 */
                var checkPendingRequests = $interval(function () {
                    if (totalActiveAjaxRequests() === 0) {
                        window.prerenderReady = true;
                        $interval.cancel(checkPendingRequests);
                    }
                }, 1000);
            });
        }]
    );

    /**
     *  Redirects to a specific state
     */
    app.run(['$log', '$rootScope', '$state', '$window', 'SearchService', 'UtilService',
             'EnerveeCheckoutService', 'CartAnalyticsService', 'SolarService',
        function ($log, $rootScope, $state, $window, SearchService, UtilService,
                  EnerveeCheckoutService, CartAnalyticsService, SolarService) {
            $rootScope.$on('$stateChangeError', function (evt, to, toParams, from, fromParams, error) {
                if (UtilService.getSetting('debug')) {
                    evt.preventDefault();
                    $log.error(error);
                }
                if (error.redirectTo) {
                    $state.go(error.redirectTo, error.params);
                }
            });
            $rootScope.$on('$stateChangeSuccess', function(evt, to, toParams, from, fromParams) {
                $state.last = from;
                if (SearchService.isAutocompleteOpen()) {
                    SearchService.closeAutocomplete();
                }
                if (UtilService.isFeatureEnabled('pick_my_solar')) {
                    SolarService.closeSolarWidget();
                }

                EnerveeCheckoutService.initializeCartFromURL().then(function (products) {
                    if (products.length > 0) {
                        CartAnalyticsService.reportEvent('Cart Engaged', {
                            location: 'mainContent',
                            type_of_change: 'Add Product',
                            source: 'url param'
                        }, products);
                    }
                });

                $window.scrollTo(0, 0);
            });
        }]
    );

    /**
     * Checks for if the state requires auth and checks if user is logged in before finishing the state change.
     */
    app.run(['$state', '$rootScope', '$stateParams', 'AccountAuthService', 'UtilService',
        function($state, $rootScope, $stateParams, AccountAuthService, UtilService) {
            $rootScope.$on('$stateChangeStart', function(evt, to, toParams, from, fromParams) {
                if (UtilService.getSetting('loggedInRequiredStates', []).indexOf(to.name) !== -1) {
                    AccountAuthService.checkIfUserLoggedIn().then(function (response) {
                        if (!response.is_authenticated) {
                            var redirectParams = {
                                next: to.name
                            };
                            if (to.name === 'rebate-claim-form') {
                                redirectParams.params = 'claim_id=' + $stateParams.claim_id;
                            }
                            $state.go('auth', redirectParams);
                        }
                    });
                }
            });
        }
    ]);

    /**
     *  Object.assign() polyfill for IE
     */
    if (typeof Object.assign != 'function') {
        (function () {
            Object.assign = function (target) {

                // We must check against these specific cases.
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var output = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source !== undefined && source !== null) {
                        for (var nextKey in source) {
                            if (source.hasOwnProperty(nextKey)) {
                                output[nextKey] = source[nextKey];
                            }
                        }
                    }
                }
                return output;
            };
        })();
    }

    /**
     * Prevent $log from congesting the console.
     * Specifically Leaflet
     */
    app.config(['$logProvider', function($logProvider) {
         $logProvider.debugEnabled(false);
    }]);

    /**
     * Adds canonical url script to all pages
     *
     */
    app.run(['$rootScope', 'UtilService', '$location',
        function($rootScope, UtilService, $location) {

            $rootScope.$on('$stateChangeSuccess', function () {
                UtilService.addCanonicalUrl($location);
            });
        }]
    );

    /**
     * Cleans up the current comparison page url cookie if not landed on the details page
     *
     */
    app.run(['$rootScope', '$state', 'ProductCompareService',
        function($rootScope, $state, ProductCompareService) {
            $rootScope.$on('$stateChangeSuccess', function () {
                if ($state.current.name !== 'product' && $state.current.name !== 'product.base') {
                    ProductCompareService.removeCurrentComparisonPageUrl();
                }
                if ($state.current.name !== 'compare') {
                    ProductCompareService.removeComparisonBackUrl();
                }
            });
        }]
    );

    /**
     * Track Pageview events with segment analytics
     */
    app.run(configurePageTracking);
    configurePageTracking.$inject = [
        '$timeout',
        '$rootScope',
        'AnalyticsService',
    ];
    function configurePageTracking(
        $timeout,
        $rootScope,
        AnalyticsService
    ) {
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (toState.name && toState.name === 'product') {
                return;
            }

            var from = {
                state: fromState,
                params: fromParams,
            };

            // The small timeout ensures that the window.location updates properly before sending this page event.
            $timeout(function () {
                AnalyticsService.trackPage(from);
            }, 1000);
        });
    }

    /**
     * Tracks Iterable callback urls with segment analytics by sending
     * an identify segment call with the url parameters
     */
    app.run(configureIterableTracking);
    configureIterableTracking.$inject = [
        '$timeout',
        '$rootScope',
        '$location',
        'AccountAuthService',
        'AnalyticsService',
        'CookiesService'
    ];
    function configureIterableTracking(
        $timeout,
        $rootScope,
        $location,
        AccountAuthService,
        AnalyticsService,
        CookiesService
    ) {
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            /**
             * Ignore the routing state (e.g. products.base) so that identify calls don't fire twice
             */
            if (toState.name.indexOf('.') === -1) {
                /**
                 * The small timeout ensures that the window.location updates
                 * properly before sending the identify event.
                 */
                $timeout(function () {
                    trackIterableLandings($location, AccountAuthService, AnalyticsService, CookiesService);
                }, 500);
            }
        });
    }

    /**
     * Triggers a tracking segment identity event for Iterable redirects/landing
     *
     * @param $location
     * @param AccountAuthService
     * @param AnalyticsService
     * @param CookiesService
     */
    function trackIterableLandings($location, AccountAuthService, AnalyticsService, CookiesService) {
        var parameters = $location.search();

        const ITERABLE_PARAMETER = "cuId";
        var ITERABLE_TRACKED_COOKIE_NAME = 'iterable_tracking';
        var iterableTrackedCookieValue = $location.url();

        // Already tracked
        var iterableTrackingCookie = CookiesService.get(ITERABLE_TRACKED_COOKIE_NAME);

        if (iterableTrackingCookie === iterableTrackedCookieValue) {
            return;
        }

        if (parameters[ITERABLE_PARAMETER]) {
            AccountAuthService.getIterableUserData(parameters[ITERABLE_PARAMETER]).then(function (userData) {
                angular.merge(userData, parameters, userData);
                return AnalyticsService.trackAnonymousUser(userData).then(function () {
                    CookiesService.set(ITERABLE_TRACKED_COOKIE_NAME, iterableTrackedCookieValue);
                });
            }, function () {
                return AnalyticsService.trackAnonymousUser(parameters).then(function () {
                    CookiesService.set(ITERABLE_TRACKED_COOKIE_NAME, iterableTrackedCookieValue);
                });
            });
        }
    }

    /**
     * Makes call to User API to verify the current user's authenticated status. If the user is authenticated, updates
     * the token expiry cookie to automatically log the user out.
     */
    app.run(verifyUserStatus);
    verifyUserStatus.$inject = [
        '$timeout',
        'AccountAuthService',
        'CmsContentService',
        'IndexService'
    ];
    function verifyUserStatus(
        $timeout,
        AccountAuthService,
        CmsContentService,
        IndexService
    ) {
        AccountAuthService.checkIfUserLoggedIn().then(function (response) {
            if (response.is_authenticated) {
                var now = new Date();

                var msUntilExpiry = new Date(response.expiration) - now;
                if (msUntilExpiry < 0) {
                    // this time has passed. set user not authenticated
                    return AccountAuthService.setIsAuthenticated(false);
                }
                var msUntilWarning = msUntilExpiry - 120000;
                if (msUntilWarning < 0) {
                    // user is already within the cutoff for logout warning, go ahead and log out.
                    return logoutUser(AccountAuthService);
                }
                // set timeout to warn user of impending logout
                $timeout(function () {
                    showLogoutWarningAlert(CmsContentService, IndexService);
                }, msUntilWarning);
                // set timeout to log out user
                $timeout(function () {
                    logoutUser(AccountAuthService);
                }, msUntilExpiry);
            }
        });
    }

    /**
     * Shows a warning alert to let the user know they are about to be logged out.
     * @param CmsContentService
     * @param IndexService
     */
    function showLogoutWarningAlert(CmsContentService, IndexService) {
        CmsContentService.getMarketPlaceText('base:logout_warning_alert').then(function (text) {
            text = text || 'Your session is about to expire. Do you want to login again?';
            var alert = {
                type: 'warning',
                message: text
            };
            IndexService.setHeaderAlerts([alert]);
        });
    }

    /**
     * Logs out the current user.
     * @param AccountAuthService
     */
    function logoutUser(AccountAuthService) {
        AccountAuthService.logout();
    }

    /**
     * Add previous page name
     */
    app.run(addPrevPageName);
    addPrevPageName.$inject = ['$rootScope'];
    function addPrevPageName($rootScope) {
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState) {
            if (toState.name && toState.name === 'product') {
                toState.prevPage = fromState.name;
            }
        });
    }

    /**
     * Sets up Reamaze tracking callback
     *
     */
    function setupReamazeTracking() {
        if (typeof(_support) === 'undefined') {
            return;
        }
        _support['analytics_track_callback'] = function (data) {
            const injector = angular.element(document.querySelector('[ng-app]')).injector();
            const analyticsService = injector.get('AnalyticsService');
            analyticsService.trackReamazeEvent(data);
        };
    }

    setupReamazeTracking();

})(window, angular);
